import type { ChartInterval } from '../types/market';

const DEFAULT_INTERVAL: ChartInterval = '15m';
const STORAGE_KEY = 'pilum.selectedInterval.v1';

const VALID_INTERVALS = new Set<ChartInterval>(['1m', '5m', '15m', '30m', '1h', '2h', '4h', '1d', '1w']);

function loadPersistedInterval(): ChartInterval {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw && VALID_INTERVALS.has(raw as ChartInterval)) return raw as ChartInterval;
  } catch {
    // storage unavailable; the in-memory default still applies
  }
  return DEFAULT_INTERVAL;
}

function persistInterval(interval: ChartInterval): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, interval);
  } catch {
    // storage unavailable; session memory still works
  }
}

let selectedInterval: ChartInterval = loadPersistedInterval();

/**
 * Return the last chart interval the user selected. The memory lives at module
 * scope and is mirrored to localStorage, so it survives the coin page unmounting
 * (navigation) AND full page reloads. It is shared across coins; the dashboard
 * horizon is mirrored into it (one-way) so the coin page follows the analysis
 * timeframe.
 */
export function getSelectedInterval(): ChartInterval {
  return selectedInterval;
}

/** Remember the user's chart-interval choice for the session and across reloads. */
export function rememberSelectedInterval(interval: ChartInterval): void {
  selectedInterval = interval;
  persistInterval(interval);
}
